// extracted by mini-css-extract-plugin
module.exports = {"achievement":"styles_achievement__fEWJp","enter":"styles_enter__7GwS0","icon":"styles_icon__4KVQC","text":"styles_text__zh5JK","points":"styles_points__emC_h"};